import React from 'react';
import { useFeaturePermission } from './usePermissions';
import { useAuth } from '../Security/AuthProvider';

/**
 * Composant wrapper pour masquer les fonctionnalités non autorisées
 */
const FeatureWrapper = ({ 
  feature, 
  children, 
  fallback = null, 
  showUpgradeMessage = false,
  className = ""
}) => {
  const { getCredentials } = useAuth();
  const credentials = getCredentials();
  const { hasPermission, loading } = useFeaturePermission(feature, credentials?.company_name);

  // Pendant le chargement, ne rien afficher
  if (loading) {
    return null;
  }

  // Si pas de permission
  if (!hasPermission) {
    // Afficher un message de mise à niveau si demandé
    if (showUpgradeMessage) {
      return (
        <div className={`feature-upgrade-message ${className}`}>
          <div className="upgrade-content">
            <span className="upgrade-icon">🔒</span>
            <span className="upgrade-text">
              Cette fonctionnalité nécessite un plan Business ou Premium
            </span>
            <button className="upgrade-button" onClick={() => {
              // TODO: Rediriger vers la page de mise à niveau
              console.log('Redirection vers la mise à niveau');
            }}>
              Mettre à niveau
            </button>
          </div>
        </div>
      );
    }
    
    // Sinon, afficher le fallback ou rien
    return fallback;
  }

  // Si permission accordée, afficher le contenu
  return children;
};

/**
 * Composant pour afficher l'état des permissions avec badge
 */
export const FeatureBadge = ({ feature, children }) => {
  const { getCredentials } = useAuth();
  const credentials = getCredentials();
  const { hasPermission, loading } = useFeaturePermission(feature, credentials?.company_name);

  if (loading) {
    return children;
  }

  return (
    <div className="feature-with-badge">
      {children}
      {!hasPermission && (
        <span className="feature-badge premium-badge">
          Premium
        </span>
      )}
    </div>
  );
};

/**
 * Hook pour obtenir facilement le statut d'une fonctionnalité
 */
export const useFeatureStatus = (feature) => {
  const { getCredentials } = useAuth();
  const credentials = getCredentials();
  return useFeaturePermission(feature, credentials?.company_name);
};

export default FeatureWrapper; 